import axios from 'axios'

/**
 * @desc Update bank details
 */
export const updateBankDetails = (payload) =>
  axios.put(`/authenticated/bank-details`, payload).then((res) => res.data)

export const createBankDetailsOnboardingSession = () =>
  axios
    .post(`/authenticated/bank-details/onboarding-session`)
    .then((res) => res.data)

export const createBankDetailsBalanceSession = () =>
  axios
    .post(`/authenticated/bank-details/balance-session`)
    .then((res) => res.data)

export const refreshBankDetailsStatus = () =>
  axios
    .post(`/authenticated/bank-details/refresh-status`)
    .then((res) => res.data)

/**
 * @desc Get bank details
 */
export const fetchBankDetails = () =>
  axios.get(`/authenticated/bank-details`).then((res) => res.data)

export const fetchBsb = (bsb) =>
  axios.get(`/authenticated/bank-details/bsb/${bsb}`).then((res) => res.data)
